import { render, staticRenderFns } from "./historic-vat-rates.vue?vue&type=template&id=2741ee51&scoped=true&"
import script from "./historic-vat-rates.vue?vue&type=script&lang=ts&"
export * from "./historic-vat-rates.vue?vue&type=script&lang=ts&"
import style0 from "./historic-vat-rates.vue?vue&type=style&index=0&id=2741ee51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2741ee51",
  null
  
)

export default component.exports